<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="pay-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <div class="pay-view">
                        <p>确定花费<b>{{ cost }}</b>梦三币<em class="icon i-m3b"></em>{{ text }}</p>
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="buy"></div>                       
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.pay-modal{
    position: relative;
    width: 667px;
    height: 378px;
    background-image: url(~@/assets/images/modal/bg-modal_sm.png);
}

.pay-view{
    padding: 80px 0 75px;
    text-align: center;
    color: #cbbda5;
}

.u-ctrl{
    display: flex;
    justify-content: center;
    align-items: center;
}

.u-ctrl .u-btn.ok{
    width: 230px;
    height: 76px;
    margin: 0 25px 0;
    background-image: url(~@/assets/images/modal/btn-submit.png);        
}

.u-ctrl .u-btn.cancel{
    width: 230px;
    height: 76px;
    margin: 0 25px 0;
    background-image: url(~@/assets/images/modal/btn-cancel.png);        
}

</style>

<script>
import {
    apiChickenBuy,
} from '@/api/index';

export default {
    data () {
        return {
            visible : false,
            gid : '2',
            giftName : '争霸奖励通道',
            cost : 599,
            num : 1,
            score : 0,
            text : '开启争霸奖励通道？',
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            apiChickenBuy({
                giftId : this.gid.toString(),
                num : this.num,
            }).then(
                res => {
                    this.$update_evt();
                    
                    this.destroyElement ();
                    this.$msg_modal({text : '购买成功'});

                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$msg_modal({text : rej.message , type : type});
                },                
            )

        },
        uflag_update (){
          this.$store.commit("$_setFlag", this.gid);
          if(this.gid == 32)this.$store.commit("$_setFlag32", 1);
        },       
    },    
}
</script>